/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const MessengerTopicType = {
    LoadSupport: 'LOAD_SUPPORT',
    CustomerSupport: 'CUSTOMER_SUPPORT',
    CarrierSupport: 'CARRIER_SUPPORT',
    UserSupport: 'USER_SUPPORT'
} as const;
export type MessengerTopicType = typeof MessengerTopicType[keyof typeof MessengerTopicType];

